import React from "react";
import styles from "./styles/viewUser.module.css";
import { loadColorCode, getSpo2Value } from "../../utils/change-spo2-color";

export function SingleVital({ fData, item, Icon, title, subTitle, field }) {
  return (
    <div className={styles.box2}>
      <p className={styles.divText}>{title}</p>
      <div className={styles.box3}>
        <Icon style={{ width: "1.67rem", height: "1.31rem" }} />

        {title === "Oxygen" ? (
          <p
            className={styles.number}
            style={loadColorCode(fData, item)}
          >
            {getSpo2Value(fData, item).value}
          </p>
        ) : (
          <p className={styles.number2}>
            {fData[String(item?.user_id)][
              fData[String(item?.user_id)]?.length - 1
            ]?.[field]
              ? fData[String(item?.user_id)][
                  fData[String(item?.user_id)]?.length - 1
                ]?.[field]
              : "-"}
          </p>
        )}

        <p className={styles.divText}>{subTitle}</p>
      </div>
    </div>
  );
}
